import { render, staticRenderFns } from "./FlowDetail.vue?vue&type=template&id=637f814c&scoped=true&"
import script from "./FlowDetail.vue?vue&type=script&lang=js&"
export * from "./FlowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f814c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637f814c')) {
      api.createRecord('637f814c', component.options)
    } else {
      api.reload('637f814c', component.options)
    }
    module.hot.accept("./FlowDetail.vue?vue&type=template&id=637f814c&scoped=true&", function () {
      api.rerender('637f814c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/FlowDetail.vue"
export default component.exports